module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 20
// module chunks = 0